// extracted by mini-css-extract-plugin
export default {"world-markets":"finance_world-markets_x","clearfix":"finance_world-markets_clearfix"};